import { createRouter, RouterOptions, createWebHashHistory, createWebHistory } from "vue-router"
import login from "./login.vue"
import frame from "./frame.vue"

import contactList from "./contactList.vue"
import projectList from "./projectList.vue"
import subProjectList from "./subProjectList.vue"
import assessmentList from "./assessmentList.vue"
import systemConfigurationThemeTemplate from "./systemConfiguration/systemConfigurationThemeTemplate.vue"
import dog from "./dog.vue"
import userList from "./userList.vue"
import userEdit from "./userEdit.vue"
import shinyPOC from "./shinyPOC.vue"
import newsList from "./newsList.vue"
import landingPage from "./landingPage.vue"
import assessment from "./assessment.vue"
import { routeGuards } from "../auth/routeGuards"
import AuthCallback from "./AuthCallback.vue"
import bookmarkedAssessmentList from "./bookmarkedAssessmentList.vue"

const routerOptions: RouterOptions = {
	history: createWebHistory("/"),
	//history: createWebHashHistory(),
	routes: [
		{ path: "/", name: "rootLogin", component: login },
		{ path: "/login", name: "login", component: login },
		{ path: "/dog", name: "dog", component: dog },
		{ path: "/login/callback", name: "callback", component: AuthCallback },
		{ path: "/logout/callback", name: "logoutCallback", component: login },
		//{ path: "/logout", name: "logout", component: login },
		{
			path: "/app",
			name: "frame",
			component: frame,
			beforeEnter: [routeGuards.requiresOktaLoginWithTheme],

			children: [
				{
					path: "",
					name: "landing",
					component: landingPage,
				},
				{
					path: "helpAdmin",
					name: "helpAdmin",
					component: () => import("./helpAdminList.vue"),
					beforeEnter: [routeGuards.requiresOktaLogin],
				},

				{
					path: "systemConfiguration",
					name: "systemConfiguration",
					component: () => import("./systemConfiguration.vue"),
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "dropdownAdministration",
					name: "dropdownAdministration",
					component: () => import("./systemConfiguration/dropdownAdministration.vue"),
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "materialAdministration",
					name: "materialAdministration",
					component: () => import("./systemConfiguration/materialAdministration.vue"),
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "transportAdministration",
					name: "transportAdministration",
					component: () => import("./transportAdministration.vue"),
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "unitOperationAdministration",
					name: "unitOperationAdministration",
					component: () => import("./systemConfiguration/unitOperationAdministration.vue"),
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "energyAdmin",
					name: "energyAdmin",
					component: () => import("./energyAdmin.vue"),
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "shinyPOC",
					name: "shinyPOC",
					component: shinyPOC,
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "contactList",
					name: "contactList",
					component: contactList,
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "userList",
					name: "userList",
					component: userList,
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "userType",
					name: "userType",
					component: () => import("./userTypeList.vue"),
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "newsList",
					name: "newsList",
					component: newsList,
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "landingPage",
					name: "landingPage",
					component: landingPage,
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "userProfile",
					name: "userProfile",
					component: () => import("./userProfile.vue"),
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "projectList",
					name: "projectList",
					component: projectList,
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "subProjectList", ///:projectId
					name: "subProjectList",
					component: subProjectList,
					props: true,
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "assessmentList", ///:subprojectId
					name: "assessmentList",
					component: assessmentList,
					props: true,
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "bookmarkedAssessmentList", ///:subprojectId
					name: "bookmarkedAssessmentList",
					component: bookmarkedAssessmentList,
					props: true,
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "assessment", ///:subprojectId
					name: "assessment",
					component: assessment,
					props: true,
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "systemConfigurationThemeTemplate",
					name: "systemConfigurationThemeTemplate",
					component: systemConfigurationThemeTemplate,
					props: true,
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "mgmSingleUtilitiesCheck",
					name: "mgmSingleUtilitiesCheck",
					component: () => import("./systemConfiguration/mgmSingleUtilitiesCheck.vue"),
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "relatableUnitAdmin",
					name: "relatableUnitAdmin",
					component: () => import("./relatableUnitAdminList.vue"),
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "relatableUnitAdminEdit/:id?",
					name: "relatableUnitAdminEdit",
					component: () => import("./relatableUnitAdminEdit.vue"),
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "materialData",
					name: "materialData",
					component: () => import("./materialDataBrowse.vue"),
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "knowledge",
					name: "knowledge-base",
					component: () => import("./knowledge/KnowledgeList.vue"),
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "knowledge/:id",
					name: "knowledge-article",
					component: () => import("./knowledge/KnowledgeArticleView.vue"),
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
				{
					path: "knowledge/:id/edit",
					name: "knowledge-article-edit",
					component: () => import("./knowledge/KnowledgeArticleDetail.vue"),
					beforeEnter: [routeGuards.requiresOktaLogin],
				},
			],
		},
	],
}

const router = createRouter(routerOptions)
export default router
